import { AbstractControl } from '@angular/forms';

export const email = (control: AbstractControl) => {
  const { value } = control;
  const matcher = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);

  if (!value || matcher.test(value)) return null;

  return { email: { message: 'E-mail inválido' } };
};
